import { DeliveryType } from "./deliveryType";

export function getReceiptTime(operationTime, deliveryType, disregardDeliveryType = false) {
    const parts = []

    if (disregardDeliveryType && deliveryType === DeliveryType.RETIRAR_NA_LOJA) {
        parts.push("Retire")
    } else if (!disregardDeliveryType) {
        parts.push(deliveryType === DeliveryType.RECEBER_EM_CASA ? "Receba" : "Retire")
    }

    const timeText = getReceiptTimeText(operationTime, deliveryType);

    if (!timeText) return;

    parts.push(timeText);

    return parts.join(" ");
}

function storeIsOpenNow(operationTime) {
    const currentDate = new Date();
    const startTimeStore = new Date(`${operationTime.data_disponibilidade}T${operationTime.hora_inicio}`);
    const endTimeStore = new Date(`${operationTime.data_disponibilidade}T${operationTime.hora_fim}`);
    return currentDate >= startTimeStore && currentDate <= endTimeStore;
}

function storeWillOpenToday(operationTime) {
    const today = new Date();

    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // mês começa do zero
    const dd = String(today.getDate()).padStart(2, '0');

    const todayStr = `${yyyy}-${mm}-${dd}`;

    if (operationTime.data_disponibilidade !== todayStr) {
        return false;
    }

    const startTimeStore = new Date(`${operationTime.data_disponibilidade}T${operationTime.hora_inicio}`);
    return today < startTimeStore;
}

export function getReceiptTimeText(operationTime, deliveryType) {
    const isOpenNow = storeIsOpenNow(operationTime);
    const willOpenToday = storeWillOpenToday(operationTime);
    if (isOpenNow) {
        return `em até ${deliveryType === DeliveryType.RECEBER_EM_CASA ? formatTime(operationTime.tempo_entrega) : formatTime(operationTime.tempo_para_retirada)}`;
    } else if (willOpenToday) {
        return `hoje a partir das ${operationTime.hora_inicio.substr(0, 5)}`;
    } else {
        var targetDate = new Date(`${operationTime.data_disponibilidade} 00:00:00`);
        var daysBetween = getDaysBetween(new Date(), targetDate);
        if (daysBetween > 0) {
            return `em ${daysBetween} dia(s)`;
        } else {
            return;
        }
    }
}

function getDaysBetween(date1, date2) {
    const msPerDay = 1000 * 60 * 60 * 24;

    // Zera as horas para considerar apenas a data (sem hora)
    const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

    return Math.floor((utc2 - utc1) / msPerDay);
}

export function formatTime(time) {
    const [hours, minutes] = time.split(':').map(Number);

    const parts = [];

    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes} min`);
    if (hours > 0 && minutes > 0) return parts.join(' e ');

    if (parts.length > 0) return parts.join('');

    return '0 min';
}

/**
 * @description Retorna a data no formato amigável
 * @param dateString data no padrão yyyy-MM-dd HH:mm-HH:mm
 */
export function getFriendlyDateForDeliveryType(dateString, deliveryType, pickupTime) {
    const [date, time] = dateString.split(" ");
    const [startTime, endTime] = time.split("-");

    const currentDate = new Date();
    const startTimeStore = new Date(`${date} ${startTime}`);
    const endTimeStore = new Date(`${date} ${endTime}`);

    let friendlyDay = "";
    const willOpenToday = currentDate < endTimeStore && currentDate.getDate() === endTimeStore.getDate() && currentDate.getMonth() === endTimeStore.getMonth() && currentDate.getFullYear() === endTimeStore.getFullYear();
    const willOpenTomorrow = currentDate.getDate() + 1 === endTimeStore.getDate() && currentDate.getMonth() === endTimeStore.getMonth() && currentDate.getFullYear() === endTimeStore.getFullYear();
    const isOpenNow = currentDate > startTimeStore && currentDate < endTimeStore;

    if (willOpenToday) {
        friendlyDay = "hoje";
    }
    else if (willOpenTomorrow) {
        friendlyDay = "amanhã";
    }
    else {
        if (getWeekNumber(currentDate) === getWeekNumber(startTimeStore)) {
            const daysOfWeek = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
            friendlyDay = daysOfWeek[startTimeStore.getDay()];
        } else {
            const [year, month, day] = date.split("-");
            friendlyDay = `${day}/${month}/${year}`;
        }
    }

    let friendlyPreposition = isOpenNow ? (deliveryType === DeliveryType.RECEBER_EM_CASA ? "até às" : "em") : "à partir das";

    let friendlyTime = isOpenNow ? (deliveryType === DeliveryType.RECEBER_EM_CASA ? endTime : formatTimeout(pickupTime)) : startTime;
    return {
        friendlyDay,
        friendlyPreposition,
        friendlyTime
    };
}

function formatTimeout(timeout) {
    // Dividir o tempo no formato HH:MM:SS
    const [hours, minutes] = timeout.split(":").map(Number);

    let result = [];

    // Adicionar horas se for maior que 0
    if (hours > 0) {
        result.push(`${hours} ${hours === 1 ? 'hora' : 'horas'}`);
    }

    // Adicionar minutos se for maior que 0
    if (minutes > 0) {
        result.push(`${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`);
    }

    // Unir o array com "e"
    return result.join(" e ");
}

/**
 * @description Retorna a data no formato amigável em string
 * @param dateString data no padrão yyyy-MM-dd HH:mm-HH:mm
 */
export function getFriendlyDateForDeliveryTypeString(dateString, deliveryType, pickupTime) {
    const friendlyDate = getFriendlyDateForDeliveryType(dateString, deliveryType, pickupTime);
    return `${friendlyDate.friendlyDay} ${friendlyDate.friendlyPreposition} ${friendlyDate.friendlyTime}`;
}

/**
 * @description Retorna o número da semana do ano
 * @param {*} date data a ser verificada
 */
const getWeekNumber = (date) => {
    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
    var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
    return weekNo;
}